import { getIconProps, type IconProps } from '#types'

/**
 * Chevron icon — single angular bracket pointing right by default.
 *
 * Rotate with Tailwind to point in any direction:
 * - right (default): no rotation
 * - left: `rotate-180`
 * - down: `rotate-90`
 * - up: `-rotate-90`
 *
 * @example
 * ```tsx
 * <ChevronIcon className="size-4" />                        // right
 * <ChevronIcon className="size-4 rotate-90" />              // down
 * <ChevronIcon className="size-4 rotate-180" />             // left
 * <ChevronIcon className="size-4 -rotate-90" />             // up
 * ```
 */
export interface ChevronIconProps extends IconProps {
  /** Stroke width (default: 2 to match the icon set spec) */
  strokeWidth?: number | string
}

export function ChevronIcon({ strokeWidth = 2, ...props }: ChevronIconProps) {
  return (
    <svg {...getIconProps(props)} viewBox="0 0 7 12" strokeWidth={strokeWidth}>
      <path
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M1,1l5,5L1,11"
      />
    </svg>
  )
}
